import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminSidebarAds from "@/pages/admin/AdminSidebarAds";

export const Route = createFileRoute("/admin/sidebar-ads")({
  component: () => (
    <ProtectedRoute>
      <AdminSidebarAds />
    </ProtectedRoute>
  ),
});
